import { openLiveStream } from './live-stream.ts'

/**
 * O Pix do atendimento — F204. As chamadas mudaram para
 * `@aeris/api-client/pix-charges` na F306 (o celular cobra pelo mesmo
 * caminho); o aviso em tempo real fica aqui, porque é o `EventSource` do
 * navegador.
 */
export * from '@aeris/api-client/pix-charges'

/**
 * O aviso em tempo real (F205). Como o do inbox: o evento só diz O QUE
 * recarregar; quem mostra o valor é a consulta normal, que já autoriza.
 */
export const openAlertStream = (handlers: {
  readonly onPixPaid: () => void
  readonly onOpen?: () => void
  readonly onClosed?: () => void
}): { close: () => void } =>
  // Reabre sozinha se cair ou emudecer (F212, `lib/live-stream.ts`); o que
  // chegou enquanto estava caída vem pelo `onResync`.
  openLiveStream({
    url: '/api/v1/alerts/events',
    onOpen: () => handlers.onOpen?.(),
    onClosed: () => handlers.onClosed?.(),
    onResync: () => {
      handlers.onPixPaid()
    },
    onMessage: (message) => {
      try {
        const data: unknown = JSON.parse(message.data)
        if (
          typeof data === 'object' &&
          data !== null &&
          'type' in data &&
          data.type === 'pix.paid'
        ) {
          handlers.onPixPaid()
        }
      } catch {
        // Um frame malformado não derruba o stream.
      }
    },
  })
